module.exports = __webpack_public_path__ + "img/slide12.74dc243a.png";